<template>
  <div class="login-page">
    <Header></Header>
    <div class="login-ctn">
      <div class="login-box">
        <div class="login-title">
          <h1>Iniciar sesión en su cuenta</h1>
        </div>
        <div class="login-form">
          <v-form
            ref="form"
            v-model="valid"
            method="post"
            enctype="multipart/form-data"
            lazy-validation
          >
            <v-text-field
              autofocus
              type="email"
              color="#ff9f1c"
              :rules="emailRules"
              label="Correo electrónico"
              outlined
              v-model="email"
            ></v-text-field>
            <v-text-field
              color="#ff9f1c"
              :rules="rulesPass"
              label="Contraseña"
              outlined
              type="password"
              v-model="password"
            ></v-text-field>

            <div class="login-btn">
              <v-btn @click="validate()" class="btn-send">INICIAR sesión</v-btn>
              <p class="line"></p>
              <v-btn class="btn-reset" text to="/forgot"
                >¿Olvido su contraseña?</v-btn
              >
            </div>
          </v-form>

          <v-alert class="alert-md" color="red" text v-if="errmensaje">{{
            errmensaje
          }}</v-alert>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import axios from "axios";
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";

export default {
  name: "Login",
  components: {
    Header,
    Footer
  },
  data() {
    return {
      email: "",
      valid: false,
      emailRules: [
        (v) => !!v || "El correo electrónico es requerido.",
        (v) =>
          !v ||
          /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,10})+$/.test(v) ||
          "El formato no es valido"
      ],
      password: "",
      rulesPass: [(v) => !!v || "La contraseña es requerida."],
      errmensaje: null
    };
  },
  methods: {
    validate() {
      if (this.$refs.form.validate()) {
        this.autenticate();
      }
    },
    autenticate() {
      const params = new URLSearchParams();
      params.append("email", this.email);
      params.append("password", this.password);
      axios
        .post("user/login", params)
        .then((response) => {
          //console.log(response.data);
          //console.log(response.data.user);
          return response.data;
        })
        .then((data) => {
          //console.log(data.tokenReturn);
          this.$store.dispatch("saveToken", data.tokenReturn);
          this.$router.push({ path: `/space` });
        })
        .catch((error) => {
          //console.log(this.email, this.password);
          this.errmensaje = null;
          if (error.response.status == 404) {
            this.errmensaje = "Usuario y/o contraseña invalidos";
          } else {
            this.errmensaje = "Ops! ocurrio un error con el servidor";
            //console.log(error);
          }
        });
    }
  }
};
</script>

<style lang="scss">
@import "../../assets/scss/base.scss";
</style>
